import { render, staticRenderFns } from "./ScheduleEditorLegend.vue?vue&type=template&id=84f40e4c&scoped=true&"
import script from "./ScheduleEditorLegend.vue?vue&type=script&lang=js&"
export * from "./ScheduleEditorLegend.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleEditorLegend.vue?vue&type=style&index=0&id=84f40e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f40e4c",
  null
  
)

export default component.exports